import { Reveal, Eyebrow } from "@/components/Reveal";
import { useSite } from "@/lib/content";

export default function FutureServices() {
  const { data } = useSite();
  const future = data?.settings?.futureServices || [];

  if (!future.length) return null;

  return (
    <section className="relative overflow-hidden border-t border-slate-800/60 bg-navy/50 py-28 sm:py-36" data-testid="future-services">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <Eyebrow>Growing Capabilities</Eyebrow>
          <h2 className="mt-4 max-w-3xl font-display text-2xl font-semibold tracking-tight text-white sm:text-3xl lg:text-4xl">
            One Technology Partner. Growing Capabilities.
          </h2>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-slate-400">
            LogiTech Nexus is being built as a broader technology services company.
            Software development is where we start — these capabilities are on our
            roadmap and will be activated as they launch.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {future.map((f, i) => (
            <Reveal key={f.name} delay={i * 0.05} y={16}>
              <div
                className={`h-full rounded-xl border p-6 transition-colors duration-300 ${
                  f.enabled
                    ? "border-blue-500/40 bg-blue-500/[0.06]"
                    : "border-dashed border-slate-800 bg-void/40"
                }`}
                data-testid={`future-service-${i}`}
              >
                <div className="flex items-center justify-between gap-3">
                  <h3 className="font-display text-sm font-semibold text-slate-200">{f.name}</h3>
                  <span
                    className={`shrink-0 rounded-full px-2.5 py-1 font-mono text-[10px] uppercase tracking-widest ${
                      f.enabled
                        ? "border border-blue-500/40 bg-blue-500/10 text-blue-300"
                        : "border border-slate-700 text-slate-500"
                    }`}
                  >
                    {f.enabled ? "Available" : "Coming Soon"}
                  </span>
                </div>
                <p className="mt-3 text-xs leading-relaxed text-slate-500">{f.blurb}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
